import styled from 'styled-components';

export const DropDownStyle = styled.div`
  .dropdownDiv {
    width: 100%;
    height: 100%;
    margin-top: 1px;
    margin-left: 5%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .dropdownMain {
    border-radius: 5px;
    font-family: 'lg-smart', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    text-align: left;
    color: #0f215f;
    border: 2px solid #96a0a8;
    gap: 5px;
    width: 100%;
    height: 35px;
    min-height: 35px;
    padding: 7px 12px;
    box-sizing: border-box;
    align-items: center;
  }
  .dropdownDiv .dropdownMain.kallos-btn,
  .dropdownDiv .dropdownMain.kallos-btn-default {
    font-size: 12px;
    line-height: 18px;
    padding: 7px 12px;
    border: 2px solid #96a0a8;
    box-sizing: border-box;
  }
  .checkbox-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    width: 100%;
    overflow: hidden;
  }

  .checkboxText {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
    color: #0f215f;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
  }
  .dropdownDiv .kallos-dropdown-item {
    padding: 6px 10px;
    font-size: 13px;
    line-height: 18px;
  }
  .heading {
    display: block;
    height: 15px;
    display: block;
    color: #6b6b6b;
    font-size: 12px;
    font-weight: 700;
    line-height: 15px;
    margin-top: 0;
    margin-bottom: 4px;
    margin-left: 2px;
  }
`;
